import { injectable } from 'inversify';
import { IAlertWordsMessageFormatter } from '@/components/chat/_domain/modules/alert-words/alert-words-service-interface';

@injectable()
class AlertWordsMessageFormatter implements IAlertWordsMessageFormatter {
    public formatMessage(message: string): string {
            const messageDiv = window.document.createElement('div');
            messageDiv.innerHTML = message;
            const unicodeFriendlyMessage: string = messageDiv.innerText;
            return unicodeFriendlyMessage;
    }
}

export { AlertWordsMessageFormatter };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/chat/_domain/modules/alert-words/alert-words-message-formatter.ts